import {MatSnackBar} from '@angular/material/snack-bar';

export const appFailure = function (popup: MatSnackBar, prefix?: string, recoveryCallback?: (a0: any, a1: string) => void) {
  prefix = prefix || 'There was an error communicating with the server';
  return function (response: any) {
    let message = prefix;
    const serverMsg = response?.error?.userMessage || response?.error?.message;
    if (serverMsg) {
      message += `: ${serverMsg}`;
    }
    if (recoveryCallback) {
      recoveryCallback(response, message);
    }

    popup.open(message, 'OK', {duration: 60000, panelClass: ['failure']});
  };
};
